import React from 'react';
import styled from 'styled-components';

import { DEFAULT_COLORS } from 'constants/colors';
import { BACK_TO_TOP_BUTTON_LABEL } from 'constants/common';

const BackToTopWrapper = styled.div`
    position: fixed;
    bottom: 1rem;
    left: 50%;
    transform: translate(-50%, 0);
    ${({ theme }) => theme.media.down('md')`
        z-index: 9999;
    `};
`;

const BackToTopButton = styled.div`
    align-items: center;
    background-color: ${DEFAULT_COLORS.LIGHTEST};
    border-radius: 0.969rem;
    border: solid 1px #e1e1e1;
    color: ${DEFAULT_COLORS.BLACK_3};
    cursor pointer;
    display: flex;
    font-family: Favorit;
    font-size: 0.75rem;
    font-weight: bold;
    justify-content: center;
    line-height: 1;
    margin: 0 auto;
    padding: 0.5625rem 0.9375rem 0.4375rem ;
`;

const BackToTop = () => {
    const [showBackToTopButton, setShowBackToTopButton] = React.useState(false);

    const handleScroll = () => {
        setShowBackToTopButton(window && window.pageYOffset > 500);
    };

    const onBackToTop = () => {
        window && window.scrollTo(0, 0);
    };

    React.useEffect(() => {
        window && window.addEventListener('scroll', handleScroll);

        return () => {
            window && window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            {showBackToTopButton && (
                <BackToTopWrapper>
                    <BackToTopButton onClick={onBackToTop}>
                        {BACK_TO_TOP_BUTTON_LABEL}
                    </BackToTopButton>
                </BackToTopWrapper>
            )}
        </>
    );
};

export default BackToTop;
